import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
  Widget,
  FormInput,
  Button,
  FormSelect,
  CrudContext,
  FormSubmitButton,
  FormatText,
  MasterDetailForm,
  FormTextArea,
  FormDatePicker,
  FormNumber,
  Col,
  FormCheckbox,
  FormSwitch,
} from '@digital/ui';
import {
  AbaGeralContrato,
  updateDadosGeraisContrato,
  updateFornecedorContrato,
  updatesDadosIniciais,
  updatesDadosConsolidados,
} from '@app/api/contrato/geral';
import { Collapse, Icon } from 'antd';
import { activeContrato, deactiveContrato, GetTakeOfByContratoId } from '@app/api/contrato';
import { hasPermission } from '@app/helpers/permissions';
import { currencyFormat, formatRealNovo, getMoney, formatReal } from '@app/helpers/numbers';
import ArquivoOriginalContrato from './ArquivoOriginalContrato';
import ModalAlterarFornecedor from './ModalAlterarFornecedor';

export const initialValuesAbaGeral: AbaGeralContrato = {
  contratoId: '',
  dadosGerais_Numero: 0,
  dadosGerais_Objeto: '',
  dadosGerais_ObjetoResumido: '',
  dadosGerais_CondicaoPagamento: '',
  fornecedor_Numero: 0,
  fornecedor_Nome: '',
  fornecedor_NomeResumido: '',
  fornecedor_Cnpj: '',
  caracteristicaServico_TipoServicoId: 'Selecione uma opção',
  caracteristicaServico_LocaisServicoList: [],
  caracteristicaServico_LocaisServicoCheckbox: [],
  caracteristicaServico_Localidade: '',
  caracteristicaServico_Descricao: '',

  dadoInicial_Valor: 0.0,
  dadoInicial_CondicaoPagamento: '',
  dadoInicial_Dias: 0,

  dadoConsolidado_Status: '',
  dadoConsolidado_ValorAtual: 0,
  dadoConsolidado_SaldoAtual: 0,
  dadoConsolidado_DiasParaEncerramento: 0,
  dadoConsolidado_Situacao: '',
  dadoInicial_Valor_String: '',
};

interface ContratoFormProps {
  onUpdate: () => any;
  geralData: AbaGeralContrato | undefined;
}

const AbaGeral = (props: ContratoFormProps) => {
  const { onUpdate, geralData } = props;
  const { selectedItem } = useContext(CrudContext);
  const [statusCodigo, setStatusCodigo] = useState();
  const [dadoInicial_teste_Valor, setDadoInicial_Valor] = useState<0>();
  const [dadoConsolidado_ValorAtual_Valor, setDadoConsolidado_ValorAtual_Valor] = useState<0>();
  const [dadoConsolidado_ValorAtual_TotalMedido, setDadoConsolidado_ValorAtual_TotalMedido] = useState<0>();
  const [modalAlterarFornecedor, setModalAlterarFornecedor] = useState(false);

  const submitDadosIniciais = (values: AbaGeralContrato) => {
    let abaGeral = { ...values };
    abaGeral.dadoInicial_Valor_String = ' ';
    if (dadoInicial_teste_Valor) {
      abaGeral.dadoInicial_Valor_String = formatReal(dadoInicial_teste_Valor);
    }
    updatesDadosIniciais(abaGeral).then(data => {
      onUpdate();
    });
  };

  const submitDadosConsolidados = (values: AbaGeralContrato) => {
    let abaGeral = { ...values };
    abaGeral.dadoConsolidado_ValorAtual_String = ' ';
    if (dadoConsolidado_ValorAtual_Valor) {
      abaGeral.dadoConsolidado_ValorAtual_String = formatReal(dadoConsolidado_ValorAtual_Valor);
    }
    updatesDadosConsolidados(abaGeral).then(data => {
      onUpdate();
    });
  };

  useEffect(() => {
    if (geralData) {
      const resultDadoInicial = geralData.dadoInicial_Valor_String.replace(/[\D]+/g, '');
      const resultValorAtualValor = geralData.dadoConsolidado_ValorAtual_String.replace(/[\D]+/g, '');
      setDadoInicial_Valor(resultDadoInicial);
      setDadoConsolidado_ValorAtual_Valor(resultValorAtualValor);
      setDadoConsolidado_ValorAtual_TotalMedido(
        geralData.dadoConsolidado_ValorAtual - geralData.dadoConsolidado_SaldoAtual,
      );
    }
  }, [geralData]);

  const submitDadosGerais = (values: any) =>
    updateDadosGeraisContrato(values).then(data => {
      onUpdate();
    });
  const submitFornecedorContrato = (values: any) =>
    updateFornecedorContrato(values).then(data => {
      onUpdate();
    });

  useEffect(() => {
    if (selectedItem) {
      setStatusCodigo(selectedItem.statusCodigo);
    }
  }, [selectedItem]);

  const activateContrato = () => {
    selectedItem &&
      activeContrato(selectedItem.id).then((resp: any) => {
        if (resp.valid) {
          onUpdate();
        }
      });
  };

  const deactivateContrato = () => {
    selectedItem &&
      deactiveContrato(selectedItem.id).then((resp: any) => {
        if (resp.valid) {
          onUpdate();
        }
      });
  };

  const { Panel } = Collapse;

  return (
    <>
      {selectedItem && (
        <ModalAlterarFornecedor
          contratoId={selectedItem.id}
          visible={modalAlterarFornecedor}
          onClose={() => setModalAlterarFornecedor(false)}
          onSuccess={onUpdate}
        />
      )}
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosGerais" header={<span>Dados Gerais do Contrato</span>} style={{ border: 0 }}>
          <MasterDetailForm
            onSubmit={submitDadosGerais}
            initialValues={geralData}
            validationSchema={Yup.object().shape({})}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_GERAL_ATIVAR_INATIVAR']) && (statusCodigo == 3 || statusCodigo == 1) ? (
                  <Button type="link" icon="media-play_round" onClick={activateContrato}>
                    Ativar Contrato
                  </Button>
                ) : (
                  () => {
                    <> </>;
                  }
                ),
                statusCodigo == 2 && hasPermission(['CONTRATO_GERAL_ATIVAR_INATIVAR']) && (
                  <Button type="link" icon="hardware-shutdown" onClick={deactivateContrato}>
                    Desativar Contrato
                  </Button>
                ),
                hasPermission(['CONTRATO_GERAL_EDITAR', 'CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO']) && (
                  <FormSubmitButton noIcon={true} type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormInput label="Numero" name="dadosGerais_Numero" span={12} disabled />
              <FormTextArea
                label="Objeto"
                name="dadosGerais_Objeto"
                rows={3}
                span={12}
                disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
      {selectedItem ? <ArquivoOriginalContrato contratoId={selectedItem.id} /> : <> </>}
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="fornecedorContrato" header={<span>Fornecedor Associado ao Contrato</span>} style={{ border: 0 }}>
          <MasterDetailForm
            initialValues={geralData}
            onSubmit={submitFornecedorContrato}
            validationSchema={Yup.object().shape({
              fornecedor_Cnpj: Yup.string().required('CNPJ deve ser informado'),
              fornecedor_Nome: Yup.string().required('Nome deve ser informado'),
            })}>
            <Widget
              actions={[
                hasPermission(['ADMINISTRADOR_DE_CONTRATO']) && (
                  <Button type="link" onClick={() => setModalAlterarFornecedor(true)}>
                    Alterar Fornecedor
                  </Button>
                ),
                hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO']) && (
                  <FormSubmitButton noIcon={true} type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormInput label="Número" name="fornecedor_Numero" span={6} disabled />
              <FormInput
                label="CNPJ"
                name="fornecedor_Cnpj"
                span={6}
                required
                disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
              />
              <FormInput
                label="Nome"
                name="fornecedor_Nome"
                span={6}
                required
                disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
              />
              <FormInput
                label="Nome Resumido"
                name="fornecedor_NomeResumido"
                span={6}
                disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosIniciais" header={<span>Dados Iniciais do Contrato</span>} style={{ border: 0 }}>
          <MasterDetailForm
            initialValues={geralData}
            onSubmit={submitDadosIniciais}
            validationSchema={Yup.object().shape({
              dadoInicial_DataInicio: Yup.string().required('Data de Início deve ser informado'),
              dadoInicial_DataTermino: Yup.string().required('Data de Término ser informado'),
            })}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO']) && (
                  <FormSubmitButton noIcon={true} type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <Col span={5}>
                <FormDatePicker
                  format="DD/MM/YYYY"
                  label="Data de Início"
                  name="dadoInicial_DataInicio"
                  span={6}
                  disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
                />
                <FormDatePicker
                  format="DD/MM/YYYY"
                  label="Data de Término"
                  name="dadoInicial_DataTermino"
                  span={6}
                  disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
                />
              </Col>

              <Col span={7}>
                <FormDatePicker
                  format="DD/MM/YYYY"
                  label="Data Ativação"
                  name="dadoInicial_DataAtivacao"
                  span={4}
                  disabled
                />

                <FormInput label="Dias" name="dadoInicial_Dias" span={4} disabled />

                <FormNumber
                  value={dadoInicial_teste_Valor}
                  label="Valor"
                  name="dadoInicial_Valor"
                  span={4}
                  formatter={(value: any) => formatReal(value)}
                  parser={(value: any) => value.replace(/[\D]+/g, '')}
                  onChange={(e: any) => setDadoInicial_Valor(e)}
                  disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
                />
              </Col>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosConsolidados" header={<span>Dados Consolidados de Contrato</span>} style={{ border: 0 }}>
          <MasterDetailForm
            onSubmit={submitDadosConsolidados}
            initialValues={geralData}
            validationSchema={Yup.object().shape({
              dadoConsolidado_DataEncerramento: Yup.string().required('Data de Encerramento deve ser informado'),
            })}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO']) && (
                  <FormSubmitButton noIcon={true} type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormDatePicker
                format="DD/MM/YYYY"
                label="Data de Encerramento"
                name="dadoConsolidado_DataEncerramento"
                span={3}
                disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
              />
              <FormInput
                label="Dias para o Encerramento"
                name="dadoConsolidado_DiasParaEncerramento"
                span={3}
                disabled
              />
              <FormInput label="Status" name="dadoConsolidado_Status" span={3} disabled />
              <FormInput label="Situação" name="dadoConsolidado_Situacao" span={3} disabled />

              <FormNumber
                value={dadoConsolidado_ValorAtual_Valor}
                label="Valor Atual do Contrato"
                name="dadoConsolidado_ValorAtual"
                span={3}
                formatter={(value: any) => formatReal(value)}
                parser={(value: any) => value.replace(/[\D]+/g, '')}
                onChange={(e: any) => setDadoConsolidado_ValorAtual_Valor(e)}
                disabled={!hasPermission(['CONTRATO_GERAL_EDITAR_DADOS_INTEGRACAO'])}
              />
              <FormNumber
                value={dadoConsolidado_ValorAtual_TotalMedido}
                label="Valor Atual Total Medido do Contrato"
                name="dadoConsolidado_ValorAtual_TotalMedido"
                span={3}
                formatter={currencyFormat}
                disabled
              />
              <FormNumber
                label="Saldo Atual do Contrato"
                formatter={currencyFormat}
                name="dadoConsolidado_SaldoAtual"
                span={3}
                disabled
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default AbaGeral;
